import React, { useEffect, useState } from 'react'
import CustomModal from '../../../../Components/custom_components/CustomModal/CustomModal'
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable'
import CustomBottomPagination from '../../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination'
import {  finances_schedule__by_id, get_schedule_by_id, get_schedule_with_pagination, schedule_creation, schedule_update } from '../../../../config/Worksite/scheduleApis'
import { handlePaginationEntries } from '../../../../utils/pagination'
import { ErrorToast, SuccessToast } from '../../../../utils/toast'
import Loader from '../../../../Components/Loader/Loader'
import { getUserData } from '../../../../utils/localStorage'
import './ScheduleSubmissionTableStyle.css'
import CustomConfirmModal from '../../../../Components/custom_components/CustomConfirmModal/CustomConfirmModal'
import ScheduleSubmissionSearchFilter from '../ScheduleSubmissionSearchFilter/ScheduleSubmissionSearchFilter'
import InvoiceForm from '../InvoiceForm/InvoiceForm'
import UpdatePaymentStatusForm from '../UpdatePaymentStatusForm/UpdatePaymentStatusForm'
import { create_invoices, schedule_move_to_finance } from '../../../../config/ScheduleReportApis/scheduleReportApis'
import { useNavigate } from 'react-router-dom'

function ScheduleSubmissionTable() {
    const userData = getUserData()
    // SUPER ADMIN 1 ADDMIN 3
    const isAdminLogin = userData?.RoleId === 1 || userData?.RoleId === 3;

    const navigate = useNavigate();

    // State variables for managing schedule data, pagination, and modal states
    const [scheduleListing, setScheduleListing] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });
    const [refresh, setRefresh] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [modalProps, setModalProps] = useState({ isOpen: false, id: '', formValues: {} });

    const [filterValues, setFilterValues] = useState({
        ScheduleCode: '',
        Survey_from_date: '',
        Survey_end_date: '',
        TechnologyId: '',
        WorksiteId: '',
        EmployeeId: '',
        EquipmentID: '',
        inv_status: 0,
    }); // Define filter values state
    const [showCheckBox, setShowCheckBox] = useState(filterValues?.inv_status == 0); //inv_status =0 not paid

    const [isLoading, setIsLoading] = useState(false); // Loader state
    const [selectedIds, setSelectedIds] = useState([]); //FOR FORWARD THE SCHEDULES ID INTO FINANCE

    const [paySubmitModal, setPaySubmitModal] = useState({
        isOpen: false,
        id: '',
    });

    // Fetch schedule data on page change or refresh
    useEffect(() => {
        fetchSchedulesforFinance();
    }, [pageNumber, totalItemPerPage, filterValues, refresh]);


    // Fetch schedule data from API
    const fetchSchedulesforFinance = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);
       
        Object.keys(filterValues).forEach(key => formData.append(key, filterValues[key]));

        try {
            setIsLoading(true)
            const response = await finances_schedule__by_id(formData);

            if (response?.status === "success") {

                const data = response?.data;
                setScheduleListing(data?.data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));
            } else {
                setScheduleListing([]);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };




    // Columns for the table
    const columns = [
        { title: "#", key: "key" },
        { title: "Schedule", key: "ScheduleCode" },
        { title: "Employee Name", key: "EmployeeName" },
        { title: "Work Site", key: "ScheduleWorksite" },
        { title: "Technology", key: "Technologyname" },
        { title: "From", key: "ScheduleStartDate" },
        { title: "To", key: "ScheduleEndDate" },
        { title: "Man Days", key: "SchedulemanDays" },
        { title: "Client Name", key: "clientName" },

    ].filter(column => column.key !== "actions" || false); //removes the "Actions" 


    // Map the schedule data into table rows
    const rows = () => scheduleListing?.map((item, index) => ({
        key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
        id: item.id,
        ScheduleCode: item.ScheduleCode,
        ScheduleStartDate: item.ScheduleStartDate,
        ScheduleEndDate: item?.ScheduleEndDate,
        SchedulemanDays: item?.SchedulemanDays,
        ScheduleWorksite: item?.ScheduleWorksite,
        Technologyname: item.Technologyname,
        EmployeeName: item.EmployeeName,
        clientName: item.clientName,
    }));


    // Open INVOICE FORM modal
    const handleInvoiceModal = async (isOpen) => {
      
        setModalProps({
            isOpen,
            id: '',
            formValues: {
                invoiceNumber: '',
                amount: '',
                description: '',
            }
        });
        // }

    };
 
    // Handle saving Invoice data (add/edit)
    const handleSaveInvoice = async (values) => {

        try {
            setIsButtonDisabled(true);
            const apiFunction = true ? create_invoices : ''

            const response = await apiFunction(values);
            const message = response?.data?.message || 'Something went wrong!';
            if (response?.data?.status === "success") {
                SuccessToast(message);
                closeModal();
                // setRefresh(!refresh);
                navigate(`/finance/invoice/list`);
                setSelectedIds([]) //clear tge selected id after successfull forward

            } else {
                ErrorToast(message);
            }
        } catch (error) {

        } finally {
            setIsButtonDisabled(false);
        }
    };
    // Close modal
    const closeModal = () => {
        setModalProps({ ...modalProps, isOpen: false });
        setIsViewModalOpen(false);
    };

    // Handle pagination changes
    const handlePageChange = (pageNumber) => setPageNumber(pageNumber);
    const handleItemPageCountChange = (pageItemCount) => setTotalItemPerPage(pageItemCount);

    // Handle search filter changes and update filter values
    const handleSearchFilter = (filterValues) => {
        setFilterValues(filterValues);
        setShowCheckBox(filterValues?.inv_status == 0)
    };

    // Close modal
    const closePaymentSubmitModal = () => {
        setPaySubmitModal({ ...modalProps, isOpen: false });
    };


    // FOR SELECET ALL FUNCTION
    const handleSelectAll = (isChecked) => {

        if (isChecked) {
            const allIds = rows()?.map((row) => row.id);
            setSelectedIds(allIds);
        } else {
            setSelectedIds([]);
        }
    };

    // FOR SELECT SCHEDULE BY ROW
    const handleSelectRow = (id) => {
        setSelectedIds((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((itemId) => itemId !== id)
                : [...prevSelected, id]
        );
    };

    const handleClearSelectedIds = () => {
        setSelectedIds([])
    }
    return (
        <>
            <div className='workforce-management-table-container'>
                <ScheduleSubmissionSearchFilter
                    tableTitle={`${isAdminLogin ? `Man-Days (Finance)` : `Man-Days`}`}
                    filterValues={filterValues}
                    searchFilter={handleSearchFilter}
                    isSendPermission={selectedIds?.length > 0}
                    handleSubmitModal={handleInvoiceModal}
                    handleClearSelectedIds={handleClearSelectedIds}

                    on_change_value={handlePageChange}
                    on_page_count_update={handleItemPageCountChange}

                />
                <div>
                    <CustomTable
                        columns={columns}
                        rows={isLoading ? [] : rows()}
                        isCheckbox={showCheckBox && rows()?.length > 0} //not show the select all check  box when no data
                        selectedIds={selectedIds}
                        handleSelectAll={handleSelectAll}
                        handleSelectRow={handleSelectRow}
                        isLoading={isLoading}
                    />
                </div>
                <div className='bottom-container'>
                    {isLoading ? <Loader /> : <CustomBottomPagination
                        items_per_page={totalItemPerPage}
                        current_page={pageNumber}
                        total_page_count={totalPages}
                        on_change_value={handlePageChange}
                        on_page_count_update={handleItemPageCountChange}
                        pagination={pagination}
                    />}
                </div>
            </div>

            {/*  Invoice Submit */}
            <CustomModal
                open={modalProps.isOpen}
                handleClose={closeModal}
                title_other=""
                title={isViewModalOpen ? "View Invoice" : modalProps.id ? "Edit Invoice" : "Create Invoice"}
                body={
                    <InvoiceForm
                        isDisabled={isViewModalOpen}
                        isButtonDisabled={isButtonDisabled}
                        id={modalProps.id}
                        selectedIds={selectedIds}
                        formValues={modalProps.formValues}
                        handleSave={handleSaveInvoice}
                    />
                }
                maxWidth="800px"
            />
            {/*    */}
            <CustomModal
                open={paySubmitModal.isOpen}
                handleClose={closePaymentSubmitModal}
                title_other=""
                title={"Pay"}
                body={
                    <UpdatePaymentStatusForm
                        initialValues={{ paidStatus: 'paid', description: '' }}
                        onSave={(data) => console.log(data)}
                        isDisabled={false}
                        isButtonDisabled={false}
                    />
                }
                maxWidth="800px"
            />

        </>
    )
}

export default ScheduleSubmissionTable